import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStoreService {
  constructor() {}

  setItem(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem(key: string): any {
    const item = localStorage.getItem(key);
    if (!item || item === 'undefined' || item === 'null') {
      // setItem(chave, undefined) grava a STRING "undefined" (JSON.stringify(undefined) é undefined);
      // sem esse guarda o JSON.parse abaixo estoura e derruba quem só queria saber se há token.
      return null;
    }

    try {
      return JSON.parse(item);
    } catch {
      return null;
    }
  }

  removeItem(key: string) {
    localStorage.removeItem(key);
  }

  /**
   * Preferências de tela que sobrevivem ao sair do sistema: o último filtro de cada relatório e a
   * opção de impressão escolhida. Não guardam nada da sessão (token, usuário, filial) — só o que a
   * pessoa marcou por último, e perder isso a cada logout ou sessão expirada obrigava a refazer
   * o filtro inteiro.
   */
  private static readonly PREFERENCIAS_DE_TELA = [
    'listagemVendasCompras', 'ListagemProduto', 'ListagemContasReceberPagar', 'ListagemClassificacaoAbc',
    'ListagemSugestoes', 'ApuracaoResultados', 'RazaoClasseGerencial', 'MovtoProdutos',
    'ListagemEtiquetaProduto', 'ListagemCadastro', 'InventarioProdutos', 'ListagemSolicitacoes',
    'ListaPreco', 'ExtratoCC'
  ];

  private ehPreferenciaDeTela(key: string): boolean {
    // cobre a chave do filtro e as derivadas dela ("X.opRel", "XComponent.opRel")
    return LocalStoreService.PREFERENCIAS_DE_TELA.some(base =>
      key === base || key.startsWith(base + '.') || key.startsWith(base + 'Component.'));
  }

  public clear() {
    const preservar: { [key: string]: string } = {};
    try {
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && this.ehPreferenciaDeTela(key)) {
          preservar[key] = localStorage.getItem(key);
        }
      }
    } catch {
      // sem acesso ao storage não há o que preservar
    }
    localStorage.clear();
    Object.keys(preservar).forEach(key => {
      try {
        localStorage.setItem(key, preservar[key]);
      } catch {
        // idem
      }
    });
  }
}